/** Used by Axios interceptors and CubeJS Api */
export const AUTH_ACCESS_TOKEN = 'spring-auth-access-token';
export const AUTH_REFRESH_TOKEN = 'spring-auth-refresh-token';

/** (On-premises) Access token is generated from the cookie set by Heracules OAuth service */
export const ACCESS_TOKEN = 'access_token';

/** Rule Set ID and Pipeline ID Keys are used for Axios Params */
export const RULESET_ID_SESSION_KEY = 'ruleSetId';
export const PIPELINE_ID_SESSION_KEY = 'pipelineId';

/** App related configuration */
export const MAX_GLOBAL_THRESHOLD = 1000000000; // $1B
export const MIN_GLOBAL_THRESHOLD = 0;

export const MAX_GLOBAL_AGGREGATE_THRESHOLD = 100;

export const MIN_ADHOC_THRESHOLD = -1000000000;

export const MAX_GLOBAL_CURRENCY = 1000000000; // $1B
export const MIN_GLOBAL_CURRENCY = 0;

export const MAX_GLOBAL_FREE_ENTRY_LENGTH = 50;
export const MIN_GLOBAL_FREE_ENTRY_LENGTH = 1;

export const MAX_NEW_CONDITIONS = 100;

// parameter service max perPage
export const MAX_32_BIT_INT = 2 ** 31 - 1;

// long polling interval times
export const RQ_LATEST_DEPLOY_PROCESS_POILLING_INTERVAL = 5000;
export const RQ_LAST_MINUTE_SIMULATIONS_POILLING_INTERVAL = 10000;

// simulation calendar date range
export const DATE_RANGE_START = -35;
export const DATE_RANGE_END = 1;

// simulation duration format for an edge case
export const ONE_DAY_STRING = '1 day';
export const TWENTY_FOUR_HOURS_STRING = '24 hours';

// we can't use the \w regex because it includes underscore
// (which is not what we want)
export const ALPHANUMERIC_REGEX = /^[\da-z]*$/i;
export const SPACE_ALPHANUMERIC_REGEX = /^[\d\sa-z]+$/i;
// identifies free entry string type whose values are separated by a comma
// or semi-colon
export const FREEENTRY_VALUE = /^[\d\sa-z,;]+$/i;
export const PCI_VALUE_INPUT = 'value-input';
export const PCI_VALUE_DECODED = 'PCI_VALUE_DECODED';
export const WHITESPACE_REGEX = /^[\S]*$/;
export const DIGITS_ONLY_REGEX = /^[\d]*$/i;
export const MERCHANT_NAME_REGEX = /^[a-zA-Z0-9_-]*$/i;
// parameter display name must be alphanumeric and cannot start with a numerical value
export const PARAMETER_DISPLAY_NAME_REGEX = /^[a-z][\d\sa-z]*$/i;
export const USER_CREATED_PARAMETER_SYSTEM_NAME_SUFFIX = '_up_';

// removes the trailing underscore and number; ex: ASMT_ACCOUNT_IDENTIFIER_3 -> ASMT_ACCOUNT_IDENTIFIER
// used in rule revision history rendering to match the correct fieldName to look up as key in fieldNameHashMap
export const CONDITION_NAME_REGEX = /(.*)_/;

// specify a regex that allows all characters
// with a min and a max - case insensitive
function minMaxAnyCharacterRegex(min: number, max: number) {
    return new RegExp(`^.{${min},${max}}$`, 'i');
}

function minAnyCharacterRegex(min: number) {
    return new RegExp(`^.{${min},}$`, 'i');
}

// specify a regex that allows alphanumeric characters
// with a min anx a max - case insensitive
function minMaxAlphaNumericRegex(min: number, max: number) {
    return new RegExp(`^[0-9a-z]{${min},${max}}$`, 'i');
}

// alphanumeric (no underscore) 0 - 20
export const ZERO_TO_20_ALPHA = minMaxAlphaNumericRegex(0, 20);

// any character (special) from 0 - 150 range
export const ZERO_TO_20_ANY = minMaxAnyCharacterRegex(0, 20);
export const ZERO_TO_150_ANY = minMaxAnyCharacterRegex(0, 150);
export const ONE_TO_150_ANY = minMaxAnyCharacterRegex(1, 150);
export const TWELVE_TO_19_ANY = minMaxAnyCharacterRegex(12, 19);
export const MINIMUM_ONE = minAnyCharacterRegex(1);

// alert banner timings
export const ALERT_BANNER_DURATION_DEFAULT = 3000;
export const ALERT_BANNER_DURATION_DEPLOY_SUCCESS = 6000;
export const ALERT_BANNER_DURATION_IMPORT_EXPORT = 6000;

export const MAX_RANGE_LIMIT = 50000;

// only number to be enter in excution order
export const AVOID_INPUT_PRIORITY = ['E', 'e', '+', '-', '.'];
export const FORBIDDEN_NUMERIC_CHARACTERS = ['E', 'e', '+'];
export const FORBIDDEN_NUMERIC_INT_CHARACTERS = ['E', 'e', '+', '.'];
export const FORBIDDEN_CURRENCY_CHARACTERS = ['E', 'e', '+', '-'];

export const EXECUTION_ORDER_MAX_DIGIT = 5;

// simulation finished banner delay
// used along with the marker set by mpgs-api to ensure that simulation is fully finished processing
export const SIMULATION_FINISHED_DELAY_MS = 20000;

export const CONFIRMED_FINISHED_SIMULATION = 'finishedSimulations';

export const ADDTIONAL_CONCLUSION_VALUES_KEY = 'additionalConclusions';

// Rule tester
export const RT_END_DATE = -1;
export const RT_DURATION = 7;
export const RT_RANGE = -42;
export const MS_PER_DAY = 1000 * 60 * 60 * 24;

// eslint-disable-next-line quotes
export const SCHEDULE_DEPLOYMENT_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm";
export const DATE_PICKER_PATTERN = '[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}';

/* List Expiry */
// eslint-disable-next-line quotes
export const LIST_ENTRY_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm";
export const MAX_MERCHANT_ID_LENGTH = 20;
export const DAY_IN_MINUTES = 60 * 24;
export const LIST_EXPIRY_START_TIME_MINUTES_OFFSET = 5;
export const LIST_EXPIRY_END_TIME_MINUTES_OFFSET = 10;
export const MIN_PARAMETER_DISPLAY_NAME_LENGTH = 1;
export const MAX_PARAMETER_DISPLAY_NAME_LENGTH = 32;

// GENERAL
export const MAX_COMMENT_LENGTH = 150;
export const GENERAL_MAX_STRING_VALUE_LENGTH = 150;
export const GENERAL_MIN_STRING_VALUE_LENGTH = 1;

/* List Import/Export */
export const FILE_UPLOAD_MAX_CHUNK_SIZE = 5 * 1024 * 1024; // 5MB
export const GET_IMPORT_EXPORT_STATUS_FREQUENCY = 10000; // in milliseconds

/** Bulk Upload List Entries
 *
 *  YYYY-MM-DD HH:MM
 *  year: any 4 digit sequence -> ([0-9]{4}
 *  month: 01 to 12 -> (0[1-9]|1[0-2])
 *  day: 01 to 31 -> (0[1-9]|[1-2][0-9]|3[0-1])
 *  hour: 00 to 23 -> ([0-1][0-9]|2[0-3])
 *  minute: 00 to 59 -> ([0-5][0-9])
 */
export const EMPTY_OR_UTC_DATE_REGEX = new RegExp(
    '^([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\\s([0-1][0-9]|2[0-3]):([0-5][0-9])$|^$',
    'i'
);

/** Velocity Parameter */
export const MAX_NUM_OF_VELOCITY_INDEXES = 2;
export const MAX_VELOCITY_FILTERS = 10;
